import { EventDispatcher } from '../webcad/flash/events';

export default class Debugger extends EventDispatcher {
  private static _instance: Debugger;

  private logText: string;

  private logTag: HTMLElement;

  private fpsTag: HTMLElement;

  private inputText1: HTMLElement;

  private inputText2: HTMLElement;

  private inputText3: HTMLElement;

  private inputText4: HTMLElement;

  public static isDebug: boolean;

  public static fontSize: string = '0.6em';

  public static fontColor: string = '#fff';

  public static initialize(container: HTMLElement): void {
    if (Debugger._instance == null) {
      Debugger._instance = new Debugger();
      Debugger._instance.logText = '';
    }

    Debugger.isDebug = true;

    const tag: HTMLElement = document.createElement('div');
    tag.setAttribute('id', 'ENIRVA_Debugger');
    tag.style.position = 'absolute';
    tag.style.right = '20px';
    tag.style.top = '30px';
    tag.style.zIndex = '99999';
    tag.style.margin = '0';
    tag.style.padding = '5px';
    tag.style.background = 'rgba(30, 30, 30, 0.75)';
    tag.style.minWidth = '100px';

    const fps: HTMLElement = document.createElement('p');
    fps.style.padding = '5px';
    fps.style.margin = '0';
    fps.style.fontSize = Debugger.fontSize;
    fps.style.color = Debugger.fontColor;
    fps.style.lineHeight = '1.5';
    fps.innerHTML = 'fps:0';

    const input: HTMLElement = document.createElement('input');
    input.setAttribute('type', 'button');
    input.setAttribute('value', 'clear');
    input.onclick = (): void => {
      Debugger.clear();
    };

    const inputT1: HTMLElement = document.createElement('input');
    inputT1.setAttribute('type', 'text');

    const inputT2: HTMLElement = document.createElement('input');
    inputT2.setAttribute('type', 'text');

    const inputT3: HTMLElement = document.createElement('input');
    inputT3.setAttribute('type', 'text');

    const inputT4: HTMLElement = document.createElement('input');
    inputT4.setAttribute('type', 'text');

    const div1: HTMLElement = document.createElement('div');
    const div2: HTMLElement = document.createElement('div');
    const div3: HTMLElement = document.createElement('div');
    const div4: HTMLElement = document.createElement('div');

    const log: HTMLElement = document.createElement('p');
    log.style.padding = '5px';
    log.style.margin = '0';
    log.style.fontSize = Debugger.fontSize;
    log.style.color = Debugger.fontColor;
    log.style.lineHeight = '1.5';

    tag.appendChild(fps);
    tag.appendChild(input);
    tag.appendChild(div1);
    tag.appendChild(div2);
    tag.appendChild(div3);
    tag.appendChild(div4);
    div1.appendChild(inputT1);
    div2.appendChild(inputT2);
    div3.appendChild(inputT3);
    div4.appendChild(inputT4);
    tag.appendChild(log);

    Debugger._instance.logTag = log;
    Debugger._instance.fpsTag = fps;
    Debugger._instance.inputText1 = inputT1;
    Debugger._instance.inputText2 = inputT2;
    Debugger._instance.inputText3 = inputT3;
    Debugger._instance.inputText4 = inputT4;
    Debugger._instance.recFps();

    container.appendChild(tag);
  }

  public static text(index: number, str: any): void {
    if (!Debugger._instance) return;
    if (index === 0) {
      $(Debugger._instance.inputText1).val(str);
    } else if (index === 1) {
      $(Debugger._instance.inputText2).val(str);
    } else if (index === 2) {
      $(Debugger._instance.inputText3).val(str);
    } else if (index === 3) {
      $(Debugger._instance.inputText4).val(str);
    } else {
      console.log(str);
    }
  }

  public static log(msg: any): void {
    if (Debugger.isDebug) {
      console.log(msg);
      Debugger._instance.logText += `${msg}<br>`;
      Debugger._instance.update();
    }
  }

  public static clear(): void {
    if (Debugger.isDebug) {
      console.log('clear ok');
      Debugger._instance.logText = '';
      Debugger._instance.update();
    }
  }

  private update(): void {
    this.logTag.innerHTML = this.logText;
  }

  private recFps(): void {
    this.useDeltaTime = true;

    let t: number = 0;
    let cc: number = 0;

    const tag: HTMLElement = this.fpsTag;

    this.onEnterFrame = (deltaTime: number): void => {
      cc += 1;
      t += deltaTime;
      if (t >= 1000) {
        tag.innerHTML = `fps:${cc.toString()}`;
        t = 0;
        cc = 0;
      }
    };
  }
}
